import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BiErrorCircle, BiImageAdd } from "react-icons/bi";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../../../constant";
import { useAuth } from "../../../context/auth-context";
import { BsCheckCircle } from "react-icons/bs";
import History from "./History";
import CtaLink, {
  buildCtaLink,
  CtaLinkState,
  emptyCtaLink,
  validateCtaLink,
} from "../../../components/CtaLink";

const PopUps = ({ setPopUpModal, setSuccessModal }: any) => {
  const [screen, setScreen] = useState<string>("New");
  const { isAuthenticated } = useAuth();
  const [error, setError] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const [signedUrl, setSignedUrl] = useState<string>("");
  const [objectUrl, setObjectUrl] = useState<string>("");
  const [urlLoading, setUrlLoading] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<string>("");
  const [isChecked, setIsChecked] = useState(false);
  const [date, setDate] = useState<string>("");
  const [time, setTime] = useState<string>("");
  const [link, setLink] = useState<CtaLinkState>(emptyCtaLink);
  const currentDate = new Date().toISOString().split("T")[0];
  const currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files ? e.target.files[0] : null;
    setFile(selectedFile);
  };

  const validate = (isChecked: boolean, date: string, time: string) => {
    if (isChecked && !date) {
      setError("Kindly add the scheduled date");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }
    if (isChecked && !time) {
      setError("Kindly add the scheduled time");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }
    setError("");
    return true;
  };

  useEffect(() => {
    axiosInstance
      .post(`${API_URL}api/notifications/advanced/request-image-upload-url`, {
        type: "popup",
      })
      .then((r: any) => {
        // console.log(r.data.data);
        setSignedUrl(r.data.data.signedURL);
        setObjectUrl(r.data.data.objectURL);
      })
      .catch((e: any) => {
        setError(e.response.data.message);
        //   setSuccess(false);
        console.log(e.respsonse.data);
      });
  }, [isAuthenticated]);
  useEffect(() => {
    if (file) {
      setUrlLoading(true);

      axios
        .put(`${signedUrl}`, file, {
          headers: {
            "Content-Type": file.type,
          },
        })
        .then((r: any) => {
          //   console.log(r);
          setUrlLoading(false);
          // console.log(file);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setUrlLoading(false);
          console.log(e.respsonse.data);
        });
    }
  }, [file, signedUrl]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!validate(isChecked, date, time)) {
      return;
    }

    const linkError = validateCtaLink(link);
    if (linkError) {
      setError(linkError);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }

    if (!loading) {
      setLoading(true);
      const data: { [key: string]: any } = {
        type: "popup",
        images: [{ url: objectUrl }],
      };
      if (date && time) {
        const combinedDateTime = new Date(`${date}T${time}`);
        data.schedule = {
          isScheduled: true,
          date: combinedDateTime.toISOString(),
        };
      } else {
        const scheduleDate = new Date();
        scheduleDate.setMinutes(scheduleDate.getMinutes() + 1);
        const isoDate = scheduleDate.toISOString();
        data.schedule = {
          isScheduled: false,
          date: isoDate,
        };
      }
      const ctaLink = buildCtaLink(link);
      if (ctaLink) {
        data.link = ctaLink;
      }
      // console.log(data);
      axiosInstance
        .post(`${API_URL}api/notifications/advanced`, data)
        .then((r: any) => {
          setLoading(false);

          setLink(emptyCtaLink);
          if (isChecked) {
            setSuccess("Image pop-up scheduled successfully");
          } else {
            setSuccess("Image pop-up sent successfully");
          }
          setTimeout(() => {
            setSuccess("");
            setPopUpModal(false);
            setSuccessModal(true);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setLoading(false);
          setTimeout(() => {
            setError("");
          }, 6000);
          console.log(e.response.data.message);
        });
    }
  };

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start overflow-auto pt-16 pb-16  bg-black bg-opacity-80 pr-10 backdrop-blur-sm">
      <div
        className={
          " w-11/12 lgss:w-2/5 transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] "
        }
      >
        <div className="flex   justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Image Pop - Ups
          </h4>
          <h4
            onClick={() => setPopUpModal((prev: any) => !prev)}
            className="text-[#78C2F7] text-[14px] font-medium cursor-pointer"
          >
            Close
          </h4>
        </div>
        <div className="w-full flex mt-4 justify-start items-center gap-4">
          <h4
            onClick={() => setScreen("New")}
            className={
              screen === "New"
                ? " text-[16px] text-gray-400 cursor-pointer font-bold "
                : " text-[14px] text-[#333F48] cursor-pointer font-bold "
            }
          >
            New
          </h4>
          <h4
            onClick={() => setScreen("History")}
            className={
              screen === "History"
                ? " text-[16px] text-gray-400  cursor-pointer font-bold "
                : " text-[14px] text-[#333F48] cursor-pointer font-bold "
            }
          >
            History
          </h4>
        </div>
        {screen === "New" ? (
          <form className="w-full mt-6" onSubmit={handleSubmit}>
            {success && (
              <div className="bg-green-600 w-full text-white  text-[16px] rounded-xl justify-start items-center gap-4 flex h-[60px] px-2 font-bold mt-4 mb-4">
                <AiOutlineCheckCircle className="text-3xl text-white" />
                {success}
              </div>
            )}
            <div className="w-full ">
              <label htmlFor="" className="font-bold text-[14px] text-white">
                Upload Image
              </label>
              <div
                onClick={() => {
                  const input = document.getElementById(
                    "fileInput"
                  ) as HTMLInputElement;
                  input.click();
                }}
                className="h-[145px] cursor-pointer w-full mt-2 text-[14px] px-8  flex flex-col justify-center items-center  font-manrope border rounded-lg border-[#141414] outline-none bg-[#1C2227]  text-[#A0A9AD] transition duration-200"
              >
                {file && urlLoading ? (
                  <TailSpin color="#0B84CB" height={25} width={25} />
                ) : file && !urlLoading ? (
                  <BsCheckCircle className="text-green-600 text-xl" />
                ) : null}
                <div className="flex justify-center items-center gap-2">
                  {!file && (
                    <BiImageAdd className="text-secondary_button text-xl" />
                  )}
                  <h4 className="font-sora text-[12px] font-bold mt-2 text-secondary_button">
                    {file ? file.name : "Click to Upload "}
                  </h4>
                </div>
                {!file && (
                  <h4 className="font-medium text-[12px] text-[#475467]">
                    SVG, PNG, JPG or GIF (max. 800x200 px)
                  </h4>
                )}
              </div>
              <input
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileUpload}
              />
            </div>

            <div className="flex  justify-start mt-6 w-full items-center gap-2">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className="h-[16px] w-[16px]"
              />
              <h4 className="text-[14px] font-bold text-white">
                Schedule notification
              </h4>
            </div>
            {isChecked && (
              <div className="w-full flex justify-center gap-4 items-center mt-6">
                <div className="w-[55%]">
                  <label className="text-[13px] font-bold text-white">
                    Select Date
                  </label>
                  <input
                    type="date"
                    value={date}
                    min={currentDate}
                    onChange={(e) => setDate(e.target.value)}
                    className="w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
                  />
                </div>
                <div className="w-[45%]">
                  <label
                    htmlFor=""
                    className="text-[13px] font-bold text-white"
                  >
                    Select Time
                  </label>
                  <input
                    type="time"
                    min={currentTime}
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    className=" w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
                  />
                </div>
              </div>
            )}
            <CtaLink value={link} onChange={setLink} />
            {error && (
              <div className="bg-red-600 text-white  text-[12px] rounded-xl justify-start items-center gap-2 flex h-[50px] px-2 font-bold mt-4">
                <BiErrorCircle className="text-xl" />
                {error}
              </div>
            )}
            <button
              type="submit"
              className="w-full h-[46px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-6"
            >
              {loading ? (
                <TailSpin color="#FFFFFF" height={30} width={30} />
              ) : (
                "Send "
              )}
            </button>
          </form>
        ) : screen === "History" ? (
          <History />
        ) : null}
      </div>
    </div>
  );
};

export default PopUps;
